import { render, staticRenderFns } from "./EmployeeInsuranceSettings.vue?vue&type=template&id=485a1896&scoped=true&"
import script from "./EmployeeInsuranceSettings.vue?vue&type=script&lang=js&"
export * from "./EmployeeInsuranceSettings.vue?vue&type=script&lang=js&"
import style0 from "./EmployeeInsuranceSettings.vue?vue&type=style&index=0&id=485a1896&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "485a1896",
  null
  
)

export default component.exports